import { useSelector } from 'react-redux';

import type { ProductInformationProps } from 'src/components/organisms/ProductInformation/components/ProductInformation';
import { selectProduct } from 'src/redux/product/selectors';

/**
 * View model for the "About this product" panel. Owns the product read and the
 * mapping, so the presentational panel stays pure props.
 *
 * Empty strings are dropped rather than passed on, because the panel omits a
 * section when its field is undefined.
 */
export type ProductInformationViewModel = Omit<ProductInformationProps, 'onVisible'>;

export const useProductInformationViewModel = (): ProductInformationViewModel => {
  const product = useSelector(selectProduct);

  return {
    dimensions: product.dimensions || undefined,
    ingredientsFileURLPath: product.ingredients ? product.ingredients.rel! : undefined,
    materials: product.materials || undefined,
    otherInformation: product.otherInformation || '',
    variationsAvailable: product.variationsAvailable || undefined,
  };
};
